export const HOST_STATUSES_PATH = '/host_statuses';
